export default {
  title: 'Request data deletion for {{name}}',
  description:
    'This creates a GDPR data-deletion request. An admin must approve it before the customer’s data is permanently deleted.',
  form: {
    note: {
      label: 'Note',
      placeholder: 'Add context for this request (optional)',
    },
  },
  buttons: {
    confirm: 'Request deletion',
  },
  toasts: {
    success: 'Data deletion request created',
    error: 'Failed to create data deletion request',
  },
};
